import { GlobalModal } from '../scripts/global/modal';

export const discountModal = () => {
  const modal = new GlobalModal();
  modal.setConfig({
    buttons: [
      {
        actionUrl: '/discount/' + backEndVars.discountData.discountSlug + '/',
        text: backEndVars.translations.tm699,
        e2e: 'apply-discount',
        id: 'apply-discount-button',
      },
    ],
    content: {
      html:
        `<div class="h-auto mx-auto discount-container">
          <h3 class="text-[20px] font-light px-10">` +
        backEndVars.translations.tm696 +
        `</h3>
          <img src="/img/icon-map.svg" />
          <h2 class="text-[25px] font-light px-10">` +
        backEndVars.translations.tm571 +
        `</h2>
          <h1 class="text-[48px] font-bold px-10">` +
        backEndVars.translations.tm697 +
        `</h1>
          <p class="text-[20px] font-light px-10">` +
        backEndVars.translations.tm698 +
        `</p>
        </div>`,
    },
    removeElements: ['closeBtn', 'circleIcon'],
    classes: {
      modal: 'discount-modal',
      body: 'noscroll-desktop',
    },
  });
  modal.init();

  let button = document.getElementById('apply-discount-button');
  if (button) {
    button.addEventListener('click', () => {
      localStorage.setItem('discountApplied', true);
    });
  }

  localStorage.setItem('discountSeen', true);
};
